import React from 'react';
import './Steps.css';

const Experience = ({ formData, setFormData, language = 'fr' }) => {
  // === TRADUCTIONS LOCALES ===
  const t = {
    title: language === 'fr' ? 'Expérience Professionnelle' : 'Professional Experience',
    expTitle: (index) => language === 'fr' ? `Expérience ${index + 1}` : `Experience ${index + 1}`,
    companyLabel: language === 'fr' ? 'Entreprise *' : 'Company *',
    companyPlaceholder: language === 'fr' ? 'Tunisie Telecom' : 'Tunisie Telecom',
    roleLabel: language === 'fr' ? 'Poste *' : 'Position *',
    rolePlaceholder: language === 'fr' 
      ? 'Stagiaire en Réseaux et Télécommunications' 
      : 'Intern in Networks and Telecommunications',
    locationLabel: language === 'fr' ? 'Lieu *' : 'Location *',
    locationPlaceholder: language === 'fr' ? 'Kairouan, Tunisie' : 'Kairouan, Tunisia',
    startLabel: language === 'fr' ? 'Date de début *' : 'Start Date *',
    startPlaceholder: language === 'fr' ? 'Juin 2023' : 'June 2023',
    endLabel: language === 'fr' ? 'Date de fin *' : 'End Date *',
    endPlaceholder: language === 'fr' ? 'Juillet 2023' : 'July 2023',
    descLabel: language === 'fr' ? 'Description *' : 'Description *',
    descPlaceholder: language === 'fr'
      ? 'Découverte et manipulation des équipements de télécommunications (Huawei MSAN et DSLAM). Participation à la configuration et maintenance des équipements de transmission.'
      : 'Discovery and handling of telecommunications equipment (Huawei MSAN and DSLAM). Participation in the configuration and maintenance of transmission equipment.',
    removeBtn: language === 'fr' ? 'Supprimer' : 'Remove',
    addBtn: language === 'fr' ? '+ Ajouter une expérience' : '+ Add Experience'
  };

  const handleExperienceChange = (index, field, value) => {
    const newExperience = [...formData.experience];
    newExperience[index][field] = value;
    setFormData(prev => ({ ...prev, experience: newExperience }));
  };

  const addExperience = () => {
    setFormData(prev => ({
      ...prev,
      experience: [
        ...prev.experience,
        { company: '', role: '', location: '', start: '', end: '', description: '' }
      ]
    }));
  };

  const removeExperience = (index) => {
    const newExperience = formData.experience.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, experience: newExperience }));
  };

  return (
    <div className="step-content">
      <h2>{t.title}</h2>
      
      {formData.experience.map((exp, index) => (
        <div key={index} className="form-item">
          <div className="item-header">
            <h3>{t.expTitle(index)}</h3>
            <button 
              type="button" 
              className="remove-btn"
              onClick={() => removeExperience(index)}
            >
              {t.removeBtn}
            </button>
          </div>

          <div className="form-grid">
            <div className="input-group">
              <label>{t.companyLabel}</label>
              <input
                type="text"
                value={exp.company}
                onChange={(e) => handleExperienceChange(index, 'company', e.target.value)}
                placeholder={t.companyPlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.roleLabel}</label>
              <input
                type="text"
                value={exp.role}
                onChange={(e) => handleExperienceChange(index, 'role', e.target.value)}
                placeholder={t.rolePlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.locationLabel}</label>
              <input
                type="text"
                value={exp.location}
                onChange={(e) => handleExperienceChange(index, 'location', e.target.value)}
                placeholder={t.locationPlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.startLabel}</label>
              <input
                type="text"
                value={exp.start}
                onChange={(e) => handleExperienceChange(index, 'start', e.target.value)}
                placeholder={t.startPlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.endLabel}</label>
              <input
                type="text"
                value={exp.end}
                onChange={(e) => handleExperienceChange(index, 'end', e.target.value)}
                placeholder={t.endPlaceholder}
                required
              />
            </div>

            <div className="input-group full-width">
              <label>{t.descLabel}</label>
              <textarea
                value={exp.description}
                onChange={(e) => handleExperienceChange(index, 'description', e.target.value)}
                placeholder={t.descPlaceholder}
                rows="3"
                required
              />
            </div>
          </div>
        </div>
      ))}

      <button type="button" className="add-btn" onClick={addExperience}>
        {t.addBtn}
      </button>
    </div>
  );
};

export default Experience;